<template>
  <section>
    <GroupTitle />
    <Feature :title="$t('CONSIGNMENT_WEEKLY_GI_DETAIL_FOR_THAILAND')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="['*' + $t('PLANT_CODE'), $t('DELTA_PN'), $t('GI_DATE'), '~', $t('REFERENCE_NO')]">
        <Select filterable v-model="plantCode" style="width: 200px" slot="a">
          <Option v-for="(item, index) in plantList" :value="item" :key="index">{{ item }}</Option>
        </Select>
        <Input v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="b" />
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_FROM')"
          slot="c"></DatePicker>
        <DatePicker v-model="validTo" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_TO')"
          slot="d"></DatePicker>
        <div slot="e" class="flex-detail">
          <Input v-model="weekNo" search :enter-button="$t('MORE')" @on-search="moreWeekNo" />
          <div class="help-text">(YYYY+WeekNumber ex. 202101)</div>
        </div>
      </FormRow>
      <ButtonRow>
        <Button type="primary" slot="0" @click="search">{{ $t('QUERY') }}</Button>
        <Button type="primary" slot="1" @click="download">{{ $t('DOWNLOAD_EXCEL') }}</Button>
        <Button type="primary" slot="2" @click="clear">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <TablePage :pageObj="pageObj" @changePage="changePage" :tableWidth="windowWidth" :columnsList="columnsList"
        :resultList="dataList" v-if="isData">
      </TablePage>

    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnModel">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="weekNoModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmWeekNoModel">
      <Input v-model="weekNoValue" type="textarea" :rows="10" />
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, DateToString, DownloadFile, ExceptionHandling } from "@/util/common"
import { AlertInfo } from "@/util/alert"
import GroupTitle from "@/views/default/GroupTitle"

export default {
  name: "WeeklyGIDetailForThailand",
  components: {
    GroupTitle
  },
  created() {
    // 原本這寫法不可能拿到 getGroupCode 的 因為在 created 的時候還沒有 getGroupCode 就想判斷有沒有是不行的
    // 就先註解掉下面的啦
    // let vueInstance = this
    // if (vueInstance.getGroupCode()) {
    //   vueInstance.toggleLoading(true)
    //   vueInstance.$consignmentHttp
    //     .get("/weeklygidetailth/plants")
    //     .then((response) => {
    //       this.toggleLoading(false)
    //       this.plantList = response.data._embedded.stringList
    //     })
    //     .catch(() => { })
    // } else {
    //   vueInstance.$router.push("/home")
    // }
  },
  watch: {
    getGroupCode: {
      immediate: true,
      handler(group) {
        if (!group) return
        this.fetchPlant(group.ecUuid)
      }
    }
  },
  data() {
    return {
      deltaPnModel: false,
      weekNoModel: false,
      plantList: [],
      plantCode: '',
      dataList: [],
      deltaPnValue: '',
      weekNoValue: '',
      validFrom: null,
      validTo: null,
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("GI_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'giDate',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PART_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'partNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorPartNo',
          width: 120,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("FI_DOCUMENT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'fiDocument',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("MM_DOC_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'mmDocument',
          width: 120,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("MM_DOC_ITEM");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'mmDocumentItem',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("MOVEMENT_TYPE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'movementType',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_NUMBER");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poNo',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("ISSUE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'issueQty',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PRICE_AND_CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'priceCurrency',
          width: 160,
          sortable: true,
          render: (h, params) => {
            let price = params.row.price ? params.row.price : ""
            let priceCurrency = params.row.priceCurrency ? params.row.priceCurrency : ""
            let text = price + " / " + priceCurrency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("INFO_AMOUNT_AND_CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'infoAmountCurrency',
          width: 160,
          sortable: true,
          render: (h, params) => {
            let infoAmount = params.row.infoAmount ? params.row.infoAmount : ""
            let infoAmountCurrency = params.row.infoAmountCurrency ? params.row.infoAmountCurrency : ""
            let text = infoAmount + " / " + infoAmountCurrency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("LOCAL_AMOUNT_AND_CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'localAmountCurrency',
          width: 160,
          sortable: true,
          render: (h, params) => {
            let localAmount = params.row.localAmount ? params.row.localAmount : ""
            let localAmountCurrency = params.row.localAmountCurrency ? params.row.localAmountCurrency : ""
            let text = localAmount + " / " + localAmountCurrency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("ACTUAL_AMOUNT_AND_CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'actualAmountCurrency',
          width: 160,
          sortable: true,
          render: (h, params) => {
            let actualAmount = params.row.actualAmount ? params.row.actualAmount : ""
            let actualAmountCurrency = params.row.actualAmountCurrency ? params.row.actualAmountCurrency : ""
            let text = actualAmount + " / " + actualAmountCurrency
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("WEEK_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'weekNo',
          width: 120,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("INVOICE_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'invoiceNo',
          width: 120,
          sortable: true,
          align: "center",
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth", "getWeeklyGiDetailForThailandPn", "getWeeklyGiDetailForThailandWeekNo", "getGroupCode"]),
    ...mapActions(["toggleLoading", "setWeeklyGiDetailForThailandPn", "setWeeklyGiDetailForThailandWeekNo"]),
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setWeeklyGiDetailForThailandPn("")
    },
    moreWeekNo() {
      this.weekNoModel = true
      this.setWeeklyGiDetailForThailandWeekNo("")
    },
    confirmDeltaPnModel() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setWeeklyGiDetailForThailandPn(this.getWeeklyGiDetailForThailandPn().concat(a.trim() + ";"))
      })
      this.setWeeklyGiDetailForThailandPn(this.getWeeklyGiDetailForThailandPn().substr(0, this.getWeeklyGiDetailForThailandPn().length - 1))
    },
    confirmWeekNoModel() {
      this.weekNoValue.split('\n').forEach(a => {
        this.setWeeklyGiDetailForThailandWeekNo(this.getWeeklyGiDetailForThailandWeekNo().concat(a.trim() + ";"))
      })
      this.setWeeklyGiDetailForThailandWeekNo(this.getWeeklyGiDetailForThailandWeekNo().substr(0, this.getWeeklyGiDetailForThailandWeekNo().length - 1))
    },
    fetchPlant(ecUuid) {
      this.toggleLoading(true)
      this.$getPlantCode(this, ecUuid).then(data => {
        this.toggleLoading(false)
        if (data) {
          this.plantList = data.map(item => item.objectKey)
        } else {
          AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH'))
        }
      })
    },
    search(init) {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        if (init) {
          vueInstance.pageObj = {
            "page": 0,
            "totalPage": 0,
            "totalCount": 0,
            "pageSize": 20
          }
        }
        let deltaPnArray = []
        vueInstance.getWeeklyGiDetailForThailandPn().split(';').forEach(a => {
          deltaPnArray.push(a)
        })
        let deltaWeekArray = []
        vueInstance.getWeeklyGiDetailForThailandWeekNo().split(';').forEach(a => {
          deltaWeekArray.push(a)
        })
        vueInstance.dataList = []
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .post("/weeklygidetailth/query?page=" + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCateria(vueInstance, deltaPnArray, deltaWeekArray)))
          .then((response) => {
            vueInstance.toggleLoading(false)
            if (response.data) {
              let data = response.data
              vueInstance.dataList = data._embedded.weeklyGiDetailForThResourceList
              vueInstance.pageObj = {
                "page": data.page.number + 1,
                "totalPage": data.page.totalPages,
                "totalCount": data.page.totalElements,
                "pageSize": data.page.size
              }
            } else {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
          })
          .catch(() => { })
      }
    },
    download() {
      let vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode)

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .post("weeklygidetailth/download", JSON.stringify(buildCateria(vueInstance)),
            { responseType: 'blob' })
          .then((response) => {
            vueInstance.toggleLoading(false)
            DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
          })
          .catch((error) => {
            vueInstance.toggleLoading(false)
            let text = ExceptionHandling(error.response)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              html: text,
            })
            vueInstance.$router.push("/home")
          })
      }
    },
    valid(plantCode) {
      let errorMessage = ""
      if (!plantCode) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PLANT_CODE') + " <br>"
      }
      return errorMessage
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    clear() {
      this.plantCode = ''
      this.deltaPn = ''
      this.deltaPnValue = ''
      this.validFrom = null
      this.validTo = null
      this.weekNo = ''
      this.weekNoValue = ''
    },
  },
  computed: {
    getGroupCode() {
      return this.$store.getters.getGroupCode
    },
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    deltaPn: {
      get() {
        return this.getWeeklyGiDetailForThailandPn()
      },
      set(value) {
        this.dataList = []
        return this.setWeeklyGiDetailForThailandPn(value)
      }
    },
    weekNo: {
      get() {
        return this.getWeeklyGiDetailForThailandWeekNo()
      },
      set(value) {
        this.dataList = []
        return this.setWeeklyGiDetailForThailandWeekNo(value)
      }
    },
  }
}

function buildCateria(vueInstance, deltaPnArray, deltaWeekArray) {
  const groupCode = vueInstance.getGroupCode;
  return {
    plant: vueInstance.plantCode,
    partNos: vueInstance.getWeeklyGiDetailForThailandPn() == "" ? [] : deltaPnArray,
    giStartDate: vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    giEndDate: vueInstance.validTo != "" && vueInstance.validTo != null ? DateToString(vueInstance.validTo, "-") : null,
    refPartNos: vueInstance.getWeeklyGiDetailForThailandWeekNo() == "" ? [] : deltaWeekArray,
    oaCode: groupCode ? groupCode.code : null
  }
}
</script>

<style scoped>
.flex-detail {
  display: inline-flex;
  align-items: center;
}

.help-text {
  white-space: nowrap;
  padding-left: 8px;
}
</style>
